import calculArrondi from '@/services/calcul/calculArrondi';

export default function calculLigneCommandeRegroupement(ligneCommande) {
  if (ligneCommande === null && ligneCommande.lignesCommande === null) {
    return;
  }
  ligneCommande.totalAvantRemise = 0;
  ligneCommande.totalHt = 0;

  ligneCommande.lignesCommande.forEach((ligne) => {
    ligneCommande.totalHt = calculArrondi(ligneCommande.totalHt + ligne.totalHt);
  });
}
